import styled from 'styled-components';

export const Container = styled.div`
    cursor: grab;
    background: white;
    height: 70px;
    width: 66px;
    color: #85859e;
    border-radius: 5px;
    text-align: center;
    font: small-caption;
    -webkit-box-shadow: 5px 5px 16px -7px #DBDBDB;
    box-shadow: 5px 5px 16px -7px #DBDBDB;
    border-style: solid;
    border-width: 1px;
    border-color: ${props => props.theme.borderColor};
}
`;

export const IconContainer = styled.div`
    margin-top: 10px; 
}
`;

export const Title = styled.div`
> p {
    font-size: 0.7em;
}
}
`;
